export default "__VITE_ASSET__724c49e9__"